// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1-D4e","validationTips":"StatementDescriptor_validationTips__3Bcok"};